export type Public<T extends object> = Pick<T, keyof T>;

export type ValueOf<T> = T[keyof T];

export const isEnumValue = <T extends Record<string, string>>(value: string, enumObj: T): value is ValueOf<T> => {
	return Object.values(enumObj).includes(value as ValueOf<T>);
};
